import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import NewsData from "../../Scripts/AppServiceContract/NewsData";
import { useView, Container, computedFrom } from 'aurelia-framework';
import { PLATFORM } from 'aurelia-pal';
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import PublicNewsAppService from "../../Scripts/AppServiceContract/PublicNewsAppService";
import { Router } from 'aurelia-router';
import { fs } from "../../../../Config/FsConfig";
import { I18N } from "aurelia-i18n";
import { EventAggregator } from 'aurelia-event-aggregator';

@useView(PLATFORM.moduleName("./News2View.html"))
export default class News2ViewEditorVM extends EditorVMBase {
  public i18n: I18N;
  public eventAggregator: EventAggregator;
  changeLocaleSubscribe: any;
  Id: string;
  Description: string;
  EffectiveDate: Date;
  FileInfoList: any;
  Title: string;
  FileInfoId: string;
  FileName: string;
  ShowDate: string;
  TypeName: string;

  router: Router
  AttachmentBaseUrl: string;

  constructor() {
    super();
    this.i18n = Container.instance.get(I18N);
    this.eventAggregator = Container.instance.get(EventAggregator);
    this.router = Container.instance.get(Router);
    this.AttachmentBaseUrl = fs.Config.ServiceBaseUrl + "modules/Aqs.AppService/UploadFileAppService/DownloadFile/id=";
    this.changeLocaleSubscribe = this.eventAggregator.subscribe('ChangeLocale', (response) => {
      if (this.Id != undefined && this.Id != null) {
        this.LoadData(this.Id);
      }
    });
  }

  activate(params, route) {
    this.LoadData(params.Id);
  }

  LoadData(data) {
    var service = Container.instance.get(PublicNewsAppService) as PublicNewsAppService
    return service.LoadNews(data).done((result) => {
      this.SetOriginalSource(result);
    }).fail(FsUtility.CommonErrorHandler);
  }

  LoadOriginalSource(originalSource: NewsData) {
    this.Id = originalSource.Id;
    this.Title = originalSource.Title;
    this.Description = originalSource.Description;
    this.TypeName = originalSource.TypeName;
    //this.EffectiveDate = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
    //this.ShowDate = new Intl.DateTimeFormat(this.i18n.tr('Aqs.Common:LangCode'), { dateStyle: 'full', timeStyle: 'short' }).format(dateTime) + this.i18n.tr('Aqs.Common:TimeUnit');
    //this.FileInfoList = originalSource.FileInfoList;
    

    let dateTime = new Date(originalSource.EffectiveDate);
    this.EffectiveDate = new Date(
      dateTime.getFullYear(),
      dateTime.getMonth(),
      dateTime.getDate()
    );
    this.ShowDate = new Intl.DateTimeFormat(this.i18n.tr("Aqs.Common:LangCode"), {
      dateStyle: "full",
      }).format(dateTime);
    this.FileInfoList = originalSource.FileInfoList;

  }

  SaveOriginalSource(originalSource: NewsData) {
    originalSource.Id = this.Id;
    originalSource.Title = this.Title;
    originalSource.Description = this.Description;
    originalSource.EffectiveDate = this.EffectiveDate;
    originalSource.FileInfoId = this.FileInfoId;
    originalSource.FileName = this.FileName;
    originalSource.FileInfoList = this.FileInfoList;
  }

  GoBack() {
    var self = this;
    this.router.navigate('Modules/Aqs/News2Page');
  }

}
